import React from 'react';
import { Grid as GridMui } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { ExtendedTheme } from 'neon-design-system';

interface ContainerProps {
	children: React.ReactNode;
	className?: string;
}

const useStyles = makeStyles((theme: ExtendedTheme) => createStyles({
	root: {
		flex: '1 1 auto',
		display: 'flex',
		flexDirection: 'column',
		width: '100%'
	},
	child: {
		flex: '1 1 auto',
		alignSelf: 'center',
		width: '100%',
		padding: theme.spacing(0, 2),
		[theme.breakpoints.down('lg')]: {
			maxWidth: 1200
		},
		[theme.breakpoints.up('xl')]: {
			maxWidth: 1440
		},
		'@media print': {
			padding: 0
		}
	}
}));

export const Container = (props: ContainerProps) => {
	const { children, className } = props;
	const classes = useStyles();

	return (
		<div className={[classes.root, className].filter((n) => !!n).join(' ')}>
			<div className={classes.child}>
				<GridMui container>
					{children}
				</GridMui>
			</div>
		</div>
	);
};

export default (Container);
